import React from 'react'
import SearchModal from '@/components/General/SearchModal'
import { View } from 'react-native'

export default function search() {
  return <View style={{flex:1, padding:10}}><SearchModal /></View>
}